import { ENGT_CHAT } from 'js/bot.model';

import { sourcePreviewHeader } from './sourcePreviewHeader.model';
import { SourcePreviewHeaderTemplate } from './sourcePreviewHeader.template';

export class SourcePreviewHeader {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvents();
	}

	initData(props) {
		this.data = sourcePreviewHeader;

		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-source-preview-header';
		wrapper.innerHTML = SourcePreviewHeaderTemplate(this.data);

		this.html = wrapper;
	}

	initEvents() {
		this.html.querySelector('.engt-source-preview-back').addEventListener('click', () => {
			ENGT_CHAT.get('onMaximizeScreen')(true);
			ENGT_CHAT.get('hideSourcePreviewScreen')();
		});
		this.html.querySelector('#engtMaximizeScreen')?.addEventListener('click', () => {
			ENGT_CHAT.get('onMaximizeScreen')();
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
